import React from "react";
import { ISpecialOfferTemplatePart, ITemplatePart } from "../../../../interfaces/DynamicCampaigns/IDynamicCampaign";
import { ConditionalOperatorsForEtaPreview } from "./TemplatePart";
import {
    INamingConvention,
    INamingConventionPart,
    INamingConventionPartValue
} from "../../../../hooks/namingConventions/useNamingConvention";
import { IConditionalField, IConditional } from "../../../../hooks/useConditionals";

interface IProps {
    item:
        | ITemplatePart
        | ISpecialOfferTemplatePart
        | INamingConvention
        | INamingConventionPart
        | INamingConventionPartValue;
}

const ConditionalsTooltipContent: React.FC<IProps> = ({ item }) => {
    return (
        <>
            <div className="uppercase text-xs font-bold text-gray-600">conditions</div>
            {item.conditionals.map((condition: IConditional | IConditionalField, i: number) => {
                const valueToDisplay = condition.value;
                // Depending on where the condition comes from we'll either have a field or a parameter
                // @ts-ignore
                const field = condition?.field ?? condition?.parameter ?? "";
                const comparator = condition.comparator;

                let valuesToDisplay: string[] | null = null;
                if (["IN", "NOTIN", "IN_LIKE", "NOTIN_LIKE"].includes(comparator || "")) {
                    valuesToDisplay = (valueToDisplay || "").split(",").filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                }

                const key = btoa((field || "0") + valueToDisplay?.replace(/[\u0250-\ue007]/g, "") + i);

                return (
                    <div key={key} className={`flex whitespace-no-wrap py-1 items-center`}>
                        <div>{field}</div>
                        <div className="ml-2">/</div>
                        <div className="ml-2">
                            {ConditionalOperatorsForEtaPreview.filter((item) => item.value === comparator)[0].label}
                        </div>
                        <div className="ml-2">/</div>
                        {valuesToDisplay !== null && (
                            <div
                                style={{ width: "500px" }}
                                className="ml-1 flex flex-wrap justify-start items-center whitespace-normal"
                            >
                                {valuesToDisplay.map((value) => (
                                    <div key={value + key} className="m-1 px-1 bg-gray-300 text-gray-800 rounded">
                                        {value}
                                    </div>
                                ))}
                            </div>
                        )}
                        {valuesToDisplay === null && (
                            <div className="m-1 px-1 bg-gray-300 text-gray-800 rounded">{valueToDisplay}</div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default ConditionalsTooltipContent;
